import type React from "react";
import { forwardRef } from "react";
import { shimmer, skeletonContainer } from "./styles.css";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
}

export const Skeleton = forwardRef(function Skeleton(
  { width, height, borderRadius, ...props }: SkeletonProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={skeletonContainer}
      style={{
        width: width,
        height: height,
        borderRadius: borderRadius,
        ...props.style,
      }}
      {...props}
    >
      <div className={shimmer} />
    </div>
  );
});

Skeleton.displayName = "Skeleton";
